/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { generateReport } from './mwts.report.thunk';

const selectSlice = ({ mwtsReport }) => mwtsReport;

const mwtsReportSlice = createSlice({
	name: 'mwtsReport',
	reducerPath: 'assetview',
	initialState: { processing: false, reports: [] },
	reducers: {},
	extraReducers: builder => {
		builder.addCase(generateReport.pending, state => {
			state.processing = true;
			state.reports = [];
		});
		builder.addCase(generateReport.fulfilled, (state, action) => {
			state.processing = false;
			const { payload } = action;
			state.reports = payload;
		});
		builder.addCase(generateReport.rejected, state => {
			state.processing = false;
		});
	},
	selectors: {
		selectProcessing: createSelector(
			[selectSlice],
			({ processing }) => processing
		),
		selectReports: createSelector([selectSlice], ({ reports }) => reports)
	}
});

export const { selectProcessing, selectReports } = mwtsReportSlice.selectors;

export default mwtsReportSlice.reducer;
